import React from 'react';

export const ArrowLeftIcon = ({ className }: { className?: string }) => {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="10"
            viewBox="0 0 15 10"
        >
            <path d="M3.21907 4.33398L6.27626 1.27679L5.33345 0.333984L0.666992 5.00044L5.33345 9.6669L6.27626 8.72409L3.21949 5.66732H14.667V4.33398H3.21907Z" />
        </svg>
    );
};
